export default __webpack_public_path__ + "static/media/backoffice_smart_packaging.c640b0ef.jpg";